module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form container"
  }, [_c('div', {
    staticClass: "form-register formResponsive"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Log In")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "inline"
  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.email),
      expression: "login.email"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.login.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "inline"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login.password),
      expression: "login.password"
    }],
    staticClass: "inline",
    attrs: {
      "type": "password",
      "name": ""
    },
    domProps: {
      "value": (_vm.login.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.login, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Log In"
    },
    on: {
      "click": function($event) {
        return _vm.validateLogin()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "validation"
  }, [_vm._v(_vm._s(_vm.loginValidation))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5937bac4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 165
// module chunks = 2